import Protein from "./Protein.js";
import Patties from "./Patties.js";
import Cooked from "./Cooked.js";
import Toppings from "./Toppings.js";
import Cheesy from "./Cheesy.js";
import Bun from "./Bun.js";
import Sauces from "./Sauces.js";
import Additional from "./Additional.js";

const Burger = () => {
  return (
    <div className="Burger">
      <div className="container">
        <form action="Submission.html" method="POST">
          <Protein />
          <hr />
          <Patties />
          <hr />
          <Cooked />
          <hr />
          <Toppings />
          <hr />
          <Cheesy />
          <hr />
          <Bun />
          <hr />
          <Sauces />
          <hr />
          <Additional />
        </form>
      </div>
      <br />
      <br />
      <hr />
    </div>
  );
};

export default Burger;
